<script lang="ts" setup>
	import type { LabelContext } from '~/stores/products/types'

	export type DropdownItemContext = Array<{
		ui?: string
		title: LabelContext
		open?: boolean
		collection: Array<LabelContext>
	}>

	const props = defineProps<{
		list: DropdownItemContext
		caption?: string
	}>()

	const collections = ref<DropdownItemContext>([])
	const template = useTemplateRef('template')
	defineExpose({ template })
	watch(
		() => props.list,
		() => {
			collections.value = props.list
		},
		{ immediate: true }
	)
</script>
<template>
	<div ref="template">
		<strong class="text-[#094163] font-semibold sm:text-lg text-base">
			{{ caption }}
		</strong>
		<ul class="w-full flexed items-start flex-col gap-y-4 justify-between pt-5">
			<li
				v-for="(item, index) in collections"
				:key="'list-item-' + index"
				:class="[item?.ui ?? 'w-full border-gray-100 border-t', !item?.collection?.length ? '' : 'py-3']"
			>
				<button
					type="button"
					class="inline-flex w-full pt-4 text-left gap-6 outline-none items-center justify-between"
					:class="{ 'cursor-text': !item?.collection?.length }"
					@click="item.open = !item.open && item?.collection?.length > 0"
				>
					<h5 class="text-base font-semibold text-gray-800" :class="item.title?.ui ?? ''">
						{{ item.title?.text ?? '' }}
					</h5>
					<span
						:class="[
							item.open ? '-rotate-180' : 'rotate-0',
							'transition-all ease-linear',
							{ hidden: !item?.collection?.length }
						]"
					>
						<tools-icon dir="arrows" icon="caret-down" path-class="stroke-gray-800" :width="30" />
					</span>
				</button>

				<div
					v-show="item?.collection?.length > 0"
					class="overflow-hidden overflow-y-auto custom-transition flex-col"
					:class="[item.open ? 'max-h-[1300px]' : 'max-h-[0]']"
				>
					<div
						v-for="(listItem, index) in item?.collection"
						:key="listItem.text + index"
						:class="listItem.ui"
					>
						<p
							:class="listItem.ui"
							v-html="listItem.text"
							class="text-gray-600 font-medium py-3 md:leading-[24px]"
						></p>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>
